var contact = function() {
    var mapMarkerIcon, mapOptions, geocoder, map, marker, submittingForm;

    var showGoogleMaps = function() {
        geocoder = new google.maps.Geocoder();
        var mapStyles = [
            {"elementType": "labels.text.stroke", "stylers": [{"color": "#fff"}]},
            {"elementType": "labels.text.fill", "stylers": [{"color": "#7f7889"}]},
            {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#e0e0e0"}]},
            {"featureType": "poi", "elementType": "geometry.fill", "stylers": [{"color": "#dfdfe1"}]},
            {"featureType": "poi", "elementType": "geometry.stroke", "stylers": [{"color": "#acaab2"}]},
            {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#6e6e6e"}]},
            {"featureType": "poi", "elementType": "labels.icon", "stylers": [{"saturation": -100}]},
            {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dbdadc"}]},
            {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#acaab2"}]},
            {"featureType": "transit", "elementType": "all", "stylers": [{"color": "#bebebe"}]},
            {"featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{"color": "#6e6e6e"}]},
            {"featureType": "transit.station", "elementType": "labels.text.stroke", "stylers": [{"color": "#efefef"}]},
            {"featureType": "water", "elementType": "all", "stylers": [{"color": "#c8c7c7"}, {"visibility": "on"}]}
        ];

        mapOptions = {
            zoom: 15,
            styles: mapStyles,
            scrollwheel: false,
            mapTypeControl: false,
            disableDefaultUI: true
        };

        map = new google.maps.Map(document.getElementById('googlemap'), mapOptions);

        google.maps.event.addListener(map, 'zoom_changed', function() {
            // Restrict min zoom
            if (map.getZoom() < 10) {
                map.setZoom(10);
            }
        });


        mapMarkerIcon = {
            url: '/assets/img/map-marker.png',
            size: new google.maps.Size(104, 152),
            scaledSize: new google.maps.Size(52, 76),
            anchor: new google.maps.Point(26, 76)
        };

        codeAddress();
    };

    var codeAddress = function() {
        geocoder.geocode({'address': address}, function(results, status) {
            if (status == 'OK') {
                map.setCenter(results[0].geometry.location);

                // Show the default red marker at the location
                marker = new google.maps.Marker({
                    position: results[0].geometry.location,
                    map: map,
                    draggable: false,
                    animation: google.maps.Animation.DROP,
                    icon: mapMarkerIcon
                });
            }
        });
    };

    return {
        init: function() {},
        showGoogleMaps: function() {
            showGoogleMaps();
        }
    }
}();

jQuery(document).ready(contact.init);

globalContact = contact;